import React, { useState } from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Image from '../elements/Image';
import Button from '../elements/Button';
import Modal from '../elements/Modal';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const B2BProductList = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  products,
  onAddToQuote,
  ...props
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const openModal = (e, product) => {
    e.preventDefault();
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setIsModalOpen(false);
    setSelectedProduct(null);
  };

  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap center-content',
    'push-left'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <div className={tilesClasses}>

            {products.map((product) => (
              <div key={product.id} className="tiles-item">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-header" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <a href="#!" onClick={(e) => openModal(e, product)} style={{ display: 'block', width: '100%', cursor: 'pointer' }}>
                      <div className="mb-16" style={{ width: '100%', height: '220px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'radial-gradient(circle at center, #182236 0%, #0B101D 100%)', borderRadius: '8px', overflow: 'hidden', padding: '16px', border: '1px solid rgba(168, 135, 86, 0.25)' }}>
                        <Image
                          src={product.imageUrl || require('./../../assets/images/no-image-available.svg')}
                          alt={product.name}
                          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                      </div>
                    </a>
                  </div>
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8" style={{ fontSize: '1.25rem' }}>
                      {product.name}
                    </h4>
                    <p className="m-0 text-sm">
                      {(product.description || 'No description available for this item.').length > 80 
                        ? `${product.description.substring(0, 80)}... ` 
                        : (product.description || 'No description available for this item.')}
                      {product.description && product.description.length > 80 && (
                        <a href="#!" onClick={(e) => openModal(e, product)} className="text-color-primary" style={{ cursor: 'pointer', textDecoration: 'none' }}>
                          View Details
                        </a>
                      )}
                    </p>
                    <div className="mt-16 text-xs text-color-high">
                      {/* MSRP Removed per user request */}
                    </div>
                    <div className="mt-24">
                      <Button color="primary" wideMobile onClick={() => onAddToQuote(product)}>
                        Add to Quote
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>
      </div>

      <Modal id="product-modal" show={isModalOpen} handleClose={closeModal}>
        {selectedProduct && (
          <div className="p-24" style={{ backgroundColor: '#141C2E', borderRadius: '8px', border: '1px solid #1E293B' }}>
            <h4 className="mt-0 mb-24 text-center" style={{ color: '#A88756' }}>{selectedProduct.name}</h4>
            <div className="mb-32" style={{ display: 'flex', justifyContent: 'center', background: 'radial-gradient(circle at center, #182236 0%, #0B101D 100%)', borderRadius: '8px', padding: '24px', border: '1px solid rgba(168, 135, 86, 0.25)' }}>
              <Image 
                src={selectedProduct.imageUrl || require('./../../assets/images/no-image-available.svg')} 
                alt={selectedProduct.name} 
                style={{ maxHeight: '300px', maxWidth: '100%', objectFit: 'contain' }} 
              />
            </div>
            <p className="text-sm m-0 pb-24" style={{ borderBottom: '1px solid #1E293B', color: '#CBD5E1' }}>
              {selectedProduct.description || 'No description available.'}
            </p>
            <div className="mt-24" style={{ textAlign: 'center' }}>
               <Button color="primary" onClick={() => { closeModal({preventDefault: () => {}}); onAddToQuote(selectedProduct); }}>
                 Add to Quote
               </Button>
            </div>
          </div>
        )}
      </Modal>
    </section>
  );
}

B2BProductList.propTypes = propTypes;
B2BProductList.defaultProps = defaultProps;

export default B2BProductList;
